import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import IconButton from '@mui/material/IconButton';
import Modal from '@mui/material/Modal';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import X from 'react-feather/dist/icons/x';
import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles';
import { CONSTANTS } from '../../../../constants/constants';
import { ModalMainContainer } from '../../../../components/NRActionModal/NRActionModal';
import NRActionModalStyles from '../../../../components/NRActionModal/NRActionModal.styles';
import NRSetupConnectionHeader from '../../../../components/NRSetupWizard/NRSetupConnectionHeader';
import JiraIcon from '../../../../NRIcons/IntegrationIcons/JiraIcon';
import { JIRA_SETUP_MODAL_LABELS } from './jiraSetup.constants';

const { CLOSE_TOOLTIP } = CONSTANTS.CONFIRMATION_MODAL;
const useStyles = makeStyles(NRActionModalStyles);

function NRJiraReconnectModal({ open, instanceUrl, connectedSpacesCount = 0, onClose, onCancel, onReauthorize, isSubmitting = false }) {
  const theme = useTheme();
  const classes = useStyles();
  const displayUrl = instanceUrl?.replace(/^https?:\/\//, '') ?? '';

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="nr-jira-reconnect-modal-title">
      <ModalMainContainer width={520} role="dialog" aria-modal="true" tabIndex={-1}>
        <Card elevation={0}>
          <CardHeader
            classes={{ root: classes.cardHeader, title: classes.cardHeaderTitle }}
            titleTypographyProps={{ id: 'nr-jira-reconnect-modal-title' }}
            title={JIRA_SETUP_MODAL_LABELS.RECONNECT_TITLE}
            action={
              <Tooltip title={CLOSE_TOOLTIP} placement="right">
                <IconButton aria-label="Close" onClick={onClose} size="large">
                  <X />
                </IconButton>
              </Tooltip>
            }
          />
          <CardContent classes={{ root: classes.cardContent }}>
            <NRSetupConnectionHeader
              leftIcon={<JiraIcon height="42" width="46" />}
              heading={`${JIRA_SETUP_MODAL_LABELS.RECONNECT_HEADING_PREFIX}${displayUrl}`}
            />
            <Typography variant="body2" color="textSecondary" textAlign="center" mb={theme.spacing(3)}>
              {JIRA_SETUP_MODAL_LABELS.RECONNECT_SUBTITLE}
            </Typography>
            <Box
              sx={{
                border: `1px solid ${theme.palette.divider}`,
                borderRadius: theme.spacing(1),
                p: theme.spacing(2),
                display: 'flex',
                flexDirection: 'column',
                gap: theme.spacing(1.5)
              }}
            >
              <Box display="flex" alignItems="center" gap={theme.spacing(1.5)}>
                <FolderOutlinedIcon sx={{ color: theme.palette.text.secondary }} aria-hidden />
                <Typography variant="body2">
                  {`${connectedSpacesCount} ${JIRA_SETUP_MODAL_LABELS.PRESERVED_SPACES_PREFIX}`}
                </Typography>
              </Box>
              <Box display="flex" alignItems="center" gap={theme.spacing(1.5)}>
                <SettingsOutlinedIcon sx={{ color: theme.palette.text.secondary }} aria-hidden />
                <Typography variant="body2">{JIRA_SETUP_MODAL_LABELS.PRESERVED_MAPPINGS}</Typography>
              </Box>
            </Box>
          </CardContent>
          <CardActions classes={{ root: classes.cardActions, spacing: classes.cardActionsSpacing }}>
            <Button variant="outlined" color="inherit" onClick={onCancel} sx={{ borderColor: theme.palette.text.border }}>
              {JIRA_SETUP_MODAL_LABELS.CANCEL}
            </Button>
            <Button
              variant="contained"
              disabled={isSubmitting}
              onClick={onReauthorize}
              endIcon={<ChevronRightIcon />}
              sx={{
                backgroundColor: theme.palette.neutral[900],
                color: theme.palette.common.white,
                '&:hover': {
                  backgroundColor: theme.palette.neutral[800]
                }
              }}
            >
              Reauthorize on Atlassian
            </Button>
          </CardActions>
        </Card>
      </ModalMainContainer>
    </Modal>
  );
}

export default NRJiraReconnectModal;
